import { useEffect, useState, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

import hero1 from "../assets/villa7.jpeg";
import hero2 from "../assets/villa9.jpeg";
import hero3 from "../assets/villa12.jpeg";
import hero4 from "../assets/villa13.jpeg";

import villa1 from "../assets/villa16.jpeg";
import villa2 from "../assets/villa15.jpg";

import heroDining from "../assets/villa8.jpeg";

import gallery1 from "../assets/villa1.jpeg";
import gallery2 from "../assets/villa4.jpeg";
import gallery3 from "../assets/villa6.jpeg";
import gallery4 from "../assets/villa7.jpeg";
import gallery5 from "../assets/villa9.jpeg";
import gallery6 from "../assets/villa13.jpeg";

function Home() {

  const gallery = [gallery1, gallery2, gallery3, gallery4, gallery5, gallery6];

  const sliderRef = useRef(null);
  const autoSlideRef = useRef(null);

  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const [current, setCurrent] = useState(0);
  const [showContent, setShowContent] = useState(false);
  const navigate = useNavigate();

  const [offerIndex, setOfferIndex] = useState(0);

  const [testimonialIndex, setTestimonialIndex] = useState(0);

  const [checkInDate, setCheckInDate] = useState("");
  const [checkOutDate, setCheckOutDate] = useState("");

  const [selectedCountry, setSelectedCountry] = useState("");

  const countries = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Democratic Republic of the Congo",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Holy See",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Ivory Coast",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Korea",
    "North Macedonia",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Korea",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Syria",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe"
  ];

  const handleMouseDown = (e) => {
    setIsDown(true);
    setStartX(e.pageX - sliderRef.current.offsetLeft);
    setScrollLeft(sliderRef.current.scrollLeft);
    clearInterval(autoSlideRef.current); // pause autoplay
  };

  const handleMouseLeave = () => {
    setIsDown(false);
    startAutoSlide(); // resume autoplay
  };

  const handleMouseUp = () => {
    setIsDown(false);
    startAutoSlide(); // resume autoplay
  };

  const handleMouseMove = (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - sliderRef.current.offsetLeft;
    const walk = (x - startX) * 1.5;
    sliderRef.current.scrollLeft = scrollLeft - walk;
  };

  const testimonials = [
    {
      title: "Unique experience",
      text: "The Water Garden is truly one of the most unique properties we have ever stayed at. It seamlessly blends a natural setting with modern amenities in each villa. Nestled in a picturesque location offering stunning views of Sigiriya Rock, it provides a serene retreat into nature. The staff was exceptionally courteous and always eager to assist.",
      author: "Aqueel",
      country: "United Arab Emirates",
    },
    {
      title: "Absolutely Stunning",
      text: "Beautiful villas, peaceful surroundings and excellent service. The architecture and landscape create a magical atmosphere that makes the stay unforgettable.",
      author: "John",
      country: "UK",
    },
    {
      title: "Luxury in Nature",
      text: "A perfect escape with breathtaking views and world-class hospitality. Everything from food to service exceeded expectations.",
      author: "Maria",
      country: "Spain",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setTestimonialIndex((prev) =>
        prev === testimonials.length - 1 ? 0 : prev + 1
      );
    }, 6000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const offers = [
    {
      title: "Exclusive 30% Savings – Credit Card",
      image: hero1,
      description: "Book your unforgettable Sigiriya escape with a special 30% discount, exclusively for selected bank credit cardholders.",
      badge: "RESIDENT OFFER",
    },
    {
      title: "Sri Lankan Offer",
      image: hero2,
      description: "Enjoy 20% off on your stay at our luxurious property surrounded by nature’s beauty and the timeless charm of Sigiriya. Whether it’s a peaceful getaway or a memorable family vacation, this is the perfect opportunity to create unforgettable moments.",
      badge: "RESIDENT OFFER",
    },
    {
      title: "Stay More and Save More",
      image: hero3,
      description: "Book a minimum of 04 nights and receive a 25% Discount on your stay at the luxurious spaces of Three Tree Villa by Habarana!",
      badge: "NON RESIDENT OFFER",
    },
    {
      title: "Early Bird Offer",
      image: hero4,
      description: "Enjoy the luxurious spaces of Three Tree Villa by Habarana by booking with us directly and take advantage of 20% Off your stay for bookings made 45 days or more in advance!",
      badge: "NON RESIDENT OFFER",
    },
    {
      title: "Last Minute Offer – 22% Off",
      image: hero1,
      description: "Enjoy the luxurious spaces of Three Tree Villa by Habarana by booking with us directly and taking advantage of 22% Off your stay for bookings made within 14 days to arrival",
      badge: "NON RESIDENT OFFER",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setOfferIndex((prev) =>
        prev === offers.length - 1 ? 0 : prev + 1
      );
    }, 5000); // 5 seconds

    return () => clearInterval(interval);
  }, [offers.length]);

  const slides = [
    {
      image: heroDining,
      title: "Romantic Fine Dining",
      subtitle: "An unforgettable candlelight experience",
    },
    {
      image: hero1,
      title: "Three Tree Villa by Habarana",
      subtitle: "Escape to Serenity",
    },
    {
      image: hero2,
      title: "Nature Meets Luxury",
      subtitle: "Awake to serene breezes and lush Blue Lotus surroundings",
    },
    {
      image: hero3,
      title: "Relax & Unwind",
      subtitle: "Peaceful stays designed for total comfort",
    },
    {
      image: hero4,
      title: "Your Serene Escape at Three Tree Villa by Habarana",
      subtitle: "Unwind in elegance, amidst tropical bliss",
    },
  ];

  const villas = [
    {
      slug: "single-room-villa",
      img: villa1,
      title: "Couple Villa",
      desc: "A romantic and peaceful retreat designed especially for couples seeking privacy, comfort, and unforgettable moments surrounded by nature.",
      details: [
        "One Spacious Bedroom",
        "One King Size Bed",
        "Private Bathroom",
        "Terrace / Garden View",
        "Ideal for 2 Guests"
      ]
    },
    {
      slug: "family-villa",
      img: villa2,
      title: "Family Villa",
      desc: "A spacious and comfortable villa perfect for families or small groups, offering relaxation, privacy, and quality time together.",
      details: [
        "Two Bedrooms",
        "1 King Size Bed + 2 Single Beds",
        "Private Bathroom",
        "Living Area",
        "Suitable for 4 Guests"
      ]
    }
  ];

  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    setShowContent(false);
    const t = setTimeout(() => setShowContent(true), 700);
    return () => clearTimeout(t);
  }, [current]);

  const containerVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1, ease: "easeOut", staggerChildren: 0.3 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  const startAutoSlide = () => {
    const slider = sliderRef.current;
    if (!slider) return;

    clearInterval(autoSlideRef.current);

    autoSlideRef.current = setInterval(() => {
      const cardWidth = slider.firstChild.offsetWidth + 32; // gap-8

      if (slider.scrollLeft + slider.clientWidth >= slider.scrollWidth) {
        slider.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        slider.scrollBy({ left: cardWidth, behavior: "smooth" });
      }
    }, 3500);
  };

  useEffect(() => {
    startAutoSlide();
    return () => clearInterval(autoSlideRef.current);
  }, []);

  return (
    <div className="w-full overflow-hidden">

      {/* ================= HERO SECTION ================= */}
      <div className="relative min-h-[85dvh] md:h-screen w-full overflow-hidden">

        {/* Background Image */}
        <motion.img
          key={current}
          src={slides[current].image}
          alt="Hero"
          className="absolute inset-0 w-full h-[100svh] md:h-full object-cover object-center"
          initial={{ opacity: 0, scale: 1.08 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.5 }}
        />

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/60"></div>

        {/* Hero Text */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          key={current}
          className="
    relative z-10 flex flex-col items-center
    justify-start md:justify-center
    h-full text-center text-white
    px-6 pt-32 md:pt-0
    max-w-3xl mx-auto
  "
        >
          <motion.h1
            variants={itemVariants}
            className="
      text-3xl sm:text-4xl md:text-6xl
      font-light tracking-widest leading-tight
    "
          >
            {slides[current].title}
          </motion.h1>

          <motion.p
            variants={itemVariants}
            className="
      mt-3 md:mt-4
      text-base sm:text-lg md:text-xl
      text-gray-300 max-w-xl
    "
          >
            {slides[current].subtitle}
          </motion.p>

          <motion.button
            variants={itemVariants}
            onClick={() => navigate("/book-now")}
            className="
      mt-6 md:mt-8
      border border-[#c9a56a]
      px-8 md:px-10 py-3
      tracking-widest
      hover:bg-[#c9a56a] hover:text-black
      transition
    "
          >
            BOOK YOUR STAY
          </motion.button>
        </motion.div>

        {/* Booking Bar */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 bg-white shadow-xl flex flex-wrap gap-4 p-4 rounded-lg z-20 w-[90%] md:w-[70%]">

          {/* Check In */}
          <div className="flex flex-col flex-1">
            <label className="text-sm text-gray-600 mb-1">Check In</label>
            <input
              type="date"
              value={checkInDate}
              onChange={(e) => setCheckInDate(e.target.value)}
              className="border px-4 py-2 outline-none"
            />
          </div>

          {/* Check Out */}
          <div className="flex flex-col flex-1">
            <label className="text-sm text-gray-600 mb-1">Check Out</label>
            <input
              type="date"
              value={checkOutDate}
              onChange={(e) => setCheckOutDate(e.target.value)}
              className="border px-4 py-2 outline-none"
            />
          </div>

          {/* Country */}
          <div className="flex flex-col flex-1">
            <label className="text-sm text-gray-600 mb-1">Country</label>
            <select
              value={selectedCountry}
              onChange={(e) => setSelectedCountry(e.target.value)}
              className="border px-4 py-2 outline-none"
            >
              <option value="">Select Country</option>
              {countries.map((country, index) => (
                <option key={index} value={country}>
                  {country}
                </option>
              ))}
            </select>
          </div>

          {/* Button */}
          <div className="flex items-end">
            <button
              onClick={() =>
                navigate("/book-now", {
                  state: {
                    checkInDate,
                    checkOutDate,
                    selectedCountry,
                  },
                })
              }
              className="bg-[#c9a56a] px-8 py-2 text-black hover:bg-black hover:text-white transition"
            >
              BOOK NOW
            </button>
          </div>

        </div>

      </div>

      {/* ================= WATER GARDEN INFO SECTION ================= */}
      <section className="bg-[#f6f4f1] py-12 sm:py-14 md:py-16 overflow-hidden">

        {/* Top heading */}
        <div className="max-w-5xl mx-auto text-center px-4 sm:px-6">
          <p className="text-[10px] sm:text-xs tracking-[0.3em] text-gray-500 mb-2 sm:mb-3">
            WHERE LUXURY MEETS NATURE
          </p>

          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light mb-4 sm:mb-6">
            Three Tree Villa by Habarana
          </h2>

          <p className="text-gray-600 leading-relaxed max-w-2xl mx-auto text-sm sm:text-base">
            A modern oasis where ancient water gardens meet luxury. Surrounded by serene lakes and
            meandering streams, this hotel offers a unique and beautiful experience.
          </p>
        </div>

        {/* Image */}
        <div className="mt-10 sm:mt-12 md:mt-14 relative z-10 flex justify-center md:justify-start px-4 sm:px-6">
          <img
            src={heroDining}
            alt="Water garden"
            className="
        w-full md:w-[85%] lg:w-[80%]
        h-[240px] sm:h-[200px] md:h-[300px] lg:h-[400px] xl:h-[500px]
        object-cover shadow-xl
      "
          />
        </div>

        {/* Benefits Section */}
        <div className="relative -mt-14 sm:-mt-16 md:-mt-20 lg:-mt-28 bg-[#0f3b3f] text-white pt-20 sm:pt-24 md:pt-32 lg:pt-44 pb-14 sm:pb-16 md:pb-20">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 grid md:grid-cols-2 gap-6 sm:gap-8 md:gap-10 items-center">

            <div>
              <p className="text-[10px] sm:text-xs tracking-[0.3em] text-gray-300 mb-2 sm:mb-3">
                RESERVE DIRECTLY FOR MORE PERKS
              </p>

              <h3 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-light">
                Book Direct Benefits
              </h3>
            </div>

            <p className="text-gray-300 leading-relaxed text-sm sm:text-base">
              Book directly with us for the best possible experience. Enjoy guaranteed lowest rates,
              exclusive perks, and personalized service. Our dedicated team ensures a seamless and
              unforgettable stay.
            </p>
          </div>

          {/* Icons */}
          <div className="max-w-5xl mx-auto px-4 sm:px-6 mt-10 sm:mt-14 md:mt-16 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 text-center gap-8 sm:gap-10 md:gap-12">
            <div>
              <div className="text-2xl sm:text-3xl mb-3 sm:mb-4">🏅</div>
              <p className="text-gray-300 text-sm sm:text-base">Best Rate Guarantee</p>
            </div>

            <div>
              <div className="text-2xl sm:text-3xl mb-3 sm:mb-4">💬</div>
              <p className="text-gray-300 text-sm sm:text-base">Exclusive Offers & Packages</p>
            </div>

            <div>
              <div className="text-2xl sm:text-3xl mb-3 sm:mb-4">🏷️</div>
              <p className="text-gray-300 text-sm sm:text-base">Personalized Service</p>
            </div>
          </div>

        </div>

      </section>

      {/* ================= VILLAS SECTION ================= */}
      <section className="bg-[#e9e3dd] py-16 -mt-20 md:py-16 md:-mt-20">

        {/* Heading */}
        <div className="max-w-5xl mx-auto text-center px-4 sm:px-6 mb-12 md:mb-16">
          <p className="text-[10px] sm:text-xs tracking-[0.3em] text-[#b89b6d] mb-3">
            UNWIND IN STYLE AND COMFORT
          </p>

          <h2 className="text-2xl sm:text-3xl md:text-5xl font-light text-gray-800 mb-4 md:mb-6">
            Your Dream Villa Awaits
          </h2>

          <p className="text-sm sm:text-base text-gray-600 leading-relaxed max-w-3xl mx-auto">
            Discover beautifully designed villas featuring private plunge pools,
            serene gardens, and elegant interiors crafted for relaxation.
          </p>
        </div>

        {/* MOBILE SLIDER + DESKTOP GRID */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex sm:grid sm:grid-cols-2 md:grid-cols-2 gap-6 md:gap-8 overflow-x-auto sm:overflow-visible snap-x snap-mandatory scrollbar-hide">
            {villas.map((villa, index) => (
              <div
                key={index}
                className="relative group overflow-hidden cursor-pointer min-w-[85%] sm:min-w-0 snap-center"
              >
                {/* Villa Image */}
                <img
                  src={villa.img}
                  alt={villa.title}
                  className="w-full h-[320px] sm:h-[420px] md:h-[520px] object-cover transition duration-700 group-hover:scale-110"
                />

                {/* Overlay */}
                <div className="absolute inset-0 bg-black/50 md:bg-black/40 md:group-hover:bg-black/75 transition duration-500 flex flex-col justify-center items-center text-white text-center px-6 sm:px-8">

                  <h3 className="text-xl sm:text-2xl md:text-3xl font-light mb-4 md:mb-6 tracking-wide">
                    {villa.title}
                  </h3>

                  <div className="flex gap-2 mb-4 md:mb-6">
                    <span className="w-2 h-2 bg-white rounded-full" />
                    <span className="w-2 h-2 bg-white rounded-full opacity-70" />
                    <span className="w-2 h-2 bg-white rounded-full opacity-40" />
                  </div>

                  {/* Description & Details - always visible on mobile */}
                  <div className="opacity-100 md:opacity-0 md:translate-y-8 md:group-hover:opacity-100 md:group-hover:translate-y-0 transition duration-700 max-w-md">
                    <p className="text-xs sm:text-sm text-gray-300 leading-relaxed mb-4 md:mb-6">
                      {villa.desc}
                    </p>

                    <div className="text-xs sm:text-sm text-gray-200 space-y-1 mb-6 md:mb-8">
                      {villa.details.map((item, i) => (
                        <p key={i}>{item}</p>
                      ))}
                    </div>

                    <button
                      onClick={() => navigate(`/villas/${villa.slug}`)}
                      className="tracking-widest text-[11px] sm:text-xs border-b border-white pb-1 hover:text-[#b89b6d] transition"
                    >
                      MORE DETAILS
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom button */}
        <div className="text-center mt-12 md:mt-16">
          <button
            onClick={() => navigate("/villas")}
            className="tracking-widest text-xs sm:text-sm border-b border-gray-700 pb-2 hover:text-[#b89b6d] transition"
          >
            VIEW ALL VILLAS
          </button>
        </div>

      </section>

      {/* ================= EXCLUSIVE ESCAPES SECTION ================= */}
      <section className="bg-[#0f3b3f] py-12 md:py-16 text-white overflow-hidden">

        <div className="max-w-[1600px] mx-auto px-5 sm:px-6 lg:px-10 grid md:grid-cols-[40%_60%] gap-10 md:gap-16 items-center">

          {/* LEFT CONTENT */}
          <div className="text-center md:text-left">
            <p className="text-[10px] sm:text-xs tracking-[0.3em] text-[#c9a56a] mb-4 md:mb-6">
              ENJOY SPECIAL DEALS TODAY
            </p>

            <h2 className="text-3xl sm:text-4xl md:text-5xl font-light mb-5 md:mb-8">
              Exclusive Escapes
            </h2>

            <p className="text-gray-300 leading-relaxed mb-8 md:mb-12 max-w-md mx-auto md:mx-0 text-sm sm:text-base">
              Discover a world of luxury and savings at Three Tree Villa by Habarana.
              Throughout the year, we offer a variety of enticing deals and
              discounts, designed to enhance your stay and make your dream
              getaway even more memorable.
            </p>

            <button
              onClick={() => navigate("/offers")}
              className="tracking-widest text-xs sm:text-sm border-b border-[#c9a56a] pb-2 hover:text-[#c9a56a] transition"
            >
              VIEW ALL OFFERS —
            </button>

            {/* SLIDER ARROWS */}
            <div className="flex justify-center md:justify-start gap-4 md:gap-6 mt-8 md:mt-12">
              <button
                onClick={() =>
                  setOfferIndex((prev) =>
                    prev === 0 ? offers.length - 1 : prev - 1
                  )
                }
                className="w-10 h-10 md:w-12 md:h-12 rounded-full border border-white/40 flex items-center justify-center hover:bg-white hover:text-black transition"
              >
                ‹
              </button>

              <button
                onClick={() =>
                  setOfferIndex((prev) =>
                    prev === offers.length - 1 ? 0 : prev + 1
                  )
                }
                className="w-10 h-10 md:w-12 md:h-12 rounded-full border border-white/40 flex items-center justify-center hover:bg-white hover:text-black transition"
              >
                ›
              </button>
            </div>
          </div>

          {/* RIGHT SLIDER */}
          <div className="overflow-hidden">
            <motion.div
              animate={{ x: `-${offerIndex * 100}%` }}
              transition={{ duration: 0.8, ease: "easeInOut" }}
              className="flex"
            >
              {offers.map((offer, index) => (
                <div
                  key={index}
                  className="min-w-full relative group cursor-pointer overflow-hidden px-2 md:px-3"
                >
                  {/* IMAGE */}
                  <img
                    src={offer.image}
                    alt={offer.title}
                    className="w-full h-[320px] sm:h-[420px] md:h-[520px] object-cover scale-100 md:group-hover:scale-110 transition duration-700"
                  />

                  {/* CONTENT (always visible on mobile) */}
                  <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6 sm:px-10 md:opacity-0 md:group-hover:opacity-100 transition duration-500">

                    <p className="text-xs sm:text-sm leading-relaxed text-gray-200 max-w-md mb-6 md:mb-8">
                      {offer.description}
                    </p>

                    <button className="tracking-widest text-xs sm:text-sm border-b border-white pb-2 hover:text-[#c9a56a] hover:border-[#c9a56a] transition">
                      MORE DETAILS
                    </button>
                  </div>

                  {/* Badge */}
                  <div className="absolute top-6 md:top-12 left-1/2 -translate-x-1/2 bg-white/70 text-black text-[10px] sm:text-xs px-3 sm:px-4 py-1 rounded-full tracking-widest">
                    {offer.badge}
                  </div>

                  {/* TITLE */}
                  <div className="absolute bottom-5 md:bottom-8 left-0 right-0 text-center md:group-hover:opacity-0 transition">
                    <h3 className="text-lg sm:text-xl md:text-2xl font-light">
                      {offer.title}
                    </h3>
                  </div>
                </div>
              ))}
            </motion.div>
          </div>
        </div>
      </section>

      {/* ================= GALLERY SECTION ================= */}
      <section className="bg-[#f6f4f1] py-16 md:py-16 overflow-hidden">

        {/* Heading */}
        <div className="max-w-6xl mx-auto px-4 sm:px-6 mb-10 md:mb-14">
          <div className="flex flex-col md:flex-row md:justify-between md:items-end gap-6">

            <div>
              <p className="text-[10px] sm:text-xs tracking-[0.3em] text-[#b89b6d] mb-3 md:mb-4">
                MOMENTS CAPTURED
              </p>

              <h2 className="text-2xl sm:text-3xl md:text-5xl font-light text-gray-800 leading-tight">
                A Glimpse into Our Splendor
              </h2>
            </div>

            <button
              onClick={() => navigate("/gallery")}
              className="self-start md:self-auto tracking-widest text-xs sm:text-sm border-b border-gray-700 pb-2 hover:text-[#b89b6d] transition"
            >
              VIEW GALLERY —
            </button>

          </div>
        </div>

        {/* AUTO + DRAG SLIDER */}
        <div
          ref={sliderRef}
          className="flex gap-2 sm:gap-4 md:gap-6 overflow-x-auto px-4 sm:px-6 cursor-grab active:cursor-grabbing scroll-smooth no-scrollbar"
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseLeave}
          onMouseUp={handleMouseUp}
          onMouseMove={handleMouseMove}
          onMouseEnter={() => clearInterval(autoSlideRef.current)}
        >
          {gallery.map((img, index) => (
            <div
              key={index}
              className="
        min-w-[75%] 
        sm:min-w-[60%] 
        md:min-w-[520px] 
        h-[320px] 
        sm:h-[420px] 
        md:h-[520px] 
        overflow-hidden
      "
            >
              <img
                src={img}
                alt="gallery"
                className="w-full h-full object-fill hover:scale-105 transition duration-700"
              />
            </div>
          ))}
        </div>
      </section>

      {/* ================= FAQ SECTION ================= */}
      <section className="bg-[#f6f4f1] pb-16">
        <div className="max-w-7xl mx-auto px-6 grid gap-12 md:grid-cols-2 items-start">

          {/* LEFT IMAGE */}
          <div>
            <img
              src={hero4}   // 👉 change to your pool image
              alt="FAQ"
              className="w-full h-[300px] sm:h-[400px] md:h-[520px] object-cover shadow-lg"
            />
          </div>

          {/* RIGHT CONTENT */}
          <div>
            <p className="text-[9px] sm:text-xs tracking-[0.3em] text-[#b89b6d] mb-3 sm:mb-4">
              FREQUENTLY ASKED QUESTIONS
            </p>

            <h2 className="text-2xl sm:text-3xl md:text-5xl font-light text-gray-800 mb-8 sm:mb-10">
              Find Your Answers
            </h2>

            {/* ACCORDION */}
            <div className="space-y-3 sm:space-y-4">

              {/* ITEM */}
              <details className="border-b pb-3 sm:pb-4 group">
                <summary className="flex justify-between cursor-pointer text-base sm:text-lg text-gray-800 font-light">
                  Do you provide airport shuttle services?
                  <span className="group-open:rotate-180 transition">⌃</span>
                </summary>

                <p className="mt-2 sm:mt-3 text-gray-600 text-sm sm:text-base leading-relaxed">
                  We provide airport shuttle services. We can arrange a private transfer for you from the airport to the hotel. Let us know your flight details, and we’ll be happy to confirm the arrangements and share the rates.
                </p>
              </details>

              {/* ITEM */}
              <details className="border-b pb-3 sm:pb-4 group">
                <summary className="flex justify-between cursor-pointer text-base sm:text-lg text-gray-800 font-light">
                  Is breakfast included in the room rate?
                  <span className="group-open:rotate-180 transition">⌃</span>
                </summary>

                <p className="mt-2 sm:mt-3 text-gray-600 text-sm sm:text-base">
                  Our rates are quoted on a bed and breakfast basis, so breakfast is included in the room rate. We do not currently offer a room-only rate.
                </p>
              </details>

              {/* ITEM */}
              <details className="border-b pb-3 sm:pb-4 group">
                <summary className="flex justify-between cursor-pointer text-base sm:text-lg text-gray-800 font-light">
                  What are the check-in and check-out times?
                  <span className="group-open:rotate-180 transition">⌃</span>
                </summary>

                <p className="mt-2 sm:mt-3 text-gray-600 text-sm sm:text-base">
                  Check-in is available from 14:00, and check-out is until 11:00. If you’d like to request an early check-in or late check-out, please feel free to make a special request when booking, and we’ll do our best to accommodate it based on availability.
                </p>
              </details>

              {/* ITEM */}
              <details className="border-b pb-3 sm:pb-4 group">
                <summary className="flex justify-between cursor-pointer text-base sm:text-lg text-gray-800 font-light">
                  Do you offer any special packages or discounts?
                  <span className="group-open:rotate-180 transition">⌃</span>
                </summary>

                <p className="mt-2 sm:mt-3 text-gray-600 text-sm sm:text-base">
                  Our website lists special discounted rates. You can also reach out to our reservations team directly; we have a variety of packages available, and we’d be glad to help you find the one that best fits your needs.
                </p>
              </details>

              {/* ITEM */}
              <details className="border-b pb-3 sm:pb-4 group">
                <summary className="flex justify-between cursor-pointer text-base sm:text-lg text-gray-800 font-light">
                  What is your cancellation policy?
                  <span className="group-open:rotate-180 transition">⌃</span>
                </summary>

                <p className="mt-2 sm:mt-3 text-gray-600 text-sm sm:text-base">
                  Our cancellation policy varies depending on the rate and dates of your reservation. Please refer to your booking confirmation for specific details or contact our reservations team for assistance.
                </p>
              </details>

            </div>
          </div>
        </div>
      </section>

      {/* ================= SUSTAINABLE STAYS SECTION ================= */}
      <section className="bg-[#0f3b3f] py-16 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-start">

          {/* LEFT CONTENT */}
          <div className="text-white max-w-xl">
            <p className="text-xs tracking-[0.3em] text-[#c9a56a] mb-4">
              OUR JOURNEY TOWARDS SUSTAINABILITY
            </p>

            <h2 className="text-4xl md:text-5xl font-light mb-6">
              Sustainable Stays
            </h2>

            <p className="text-gray-300 leading-relaxed">
              A range of initiatives have been implemented and are currently in progress to
              enhance the sustainability of our operations. These measures aim to reduce our
              environmental footprint and promote responsible practices.
            </p>

            {/* IMAGE 1 */}
            <img
              src={gallery4}   // 👉 change to your paddy field image
              alt="Sustainable stay"
              className="mt-12 w-full h-[380px] object-cover shadow-xl"
            />
          </div>

          {/* RIGHT IMAGE */}
          <div className="relative">
            <img
              src={gallery5}   // 👉 change to your villa bicycle image
              alt="Eco villa"
              className="w-full h-[520px] object-cover shadow-xl"
            />
          </div>

        </div>
      </section>

      {/* ================= MEMORABLE STAYS TEXT SLIDER section ================= */}
      <section className="bg-[#e9e3dd] py-16 text-center overflow-hidden">

        <div className="max-w-4xl mx-auto px-6 relative">

          <p className="text-xs tracking-[0.3em] text-[#b89b6d] mb-6">
            WHAT OUR GUESTS ARE SAYING
          </p>

          <h2 className="text-5xl font-light text-gray-800 mb-10">
            Memorable Stays
          </h2>

          {/* SLIDER */}
          <motion.div
            key={testimonialIndex}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h3 className="text-2xl font-light mb-6 text-gray-700">
              {testimonials[testimonialIndex].title}
            </h3>

            <p className="text-gray-600 leading-relaxed mb-8">
              {testimonials[testimonialIndex].text}
            </p>

            <p className="text-sm text-gray-500 tracking-wide">
              — {testimonials[testimonialIndex].author} |{" "}
              {testimonials[testimonialIndex].country} —
            </p>
          </motion.div>

          {/* ARROWS */}
          <button
            onClick={() =>
              setTestimonialIndex((prev) =>
                prev === 0 ? testimonials.length - 1 : prev - 1
              )
            }
            className="absolute -left-20 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full border border-gray-400 flex items-center justify-center hover:bg-black hover:text-white transition"
          >
            ‹
          </button>

          <button
            onClick={() =>
              setTestimonialIndex((prev) =>
                prev === testimonials.length - 1 ? 0 : prev + 1
              )
            }
            className="absolute -right-20 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full border border-gray-400 flex items-center justify-center hover:bg-black hover:text-white transition"
          >
            ›
          </button>

        </div>
      </section>

      {/* ================= WHATSAPP BUTTON ================= */}
      <a
        href="https://wa.me/94764806045?text=I%20saw%20your%20website.%20Can%20you%20give%20me%20information%20regarding%20your%20villa."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-5 right-5 z-50"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
          alt="WhatsApp"
          className="h-12 w-12 sm:h-14 sm:w-14 rounded-full shadow-lg transition hover:scale-110"
        />
      </a>

    </div>
  );
}

export default Home;
